import { Moment } from 'moment'
import React from 'react'

import { useWindowDimensions } from '../Common/Hooks/useWindowDimensions'

import { DateText } from './DateText/DateText'

interface IProps {
  date: Moment
}

export const DayHeader = ({ date }: IProps) => {
  const { windowWidth } = useWindowDimensions()
  return (
    <div style={{ color: 'black', textAlign: 'center' }}>
      <DateText
        format={windowWidth < 915 ? 'extra-short' : 'medium'}
        date={date}
      />
    </div>
  )
}
